export default __webpack_public_path__ + "static/media/chat-image.aae90ef5.jpg";